(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-variant-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__variantPickerSelectedValueBound) return;
    window.__variantPickerSelectedValueBound = true;

    const GALLERY_SELECTORS = [
      'media-gallery',
      'product-gallery',
      '.product-gallery',
      '.product__media',
      '.product-media',
      '[data-product-media]',
      '.product__media-wrapper',
    ];
    const HEADER_OFFSET = 80;

    function findGallery(fromEl) {
      const section = fromEl.closest('.shopify-section') || document;
      for (const sel of GALLERY_SELECTORS) {
        const el = section.querySelector(sel) || document.querySelector(sel);
        if (el) return el;
      }
      return section.querySelector('img');
    }

    function scrollToGallery(fromEl) {
      const gallery = findGallery(fromEl);
      if (!gallery) return;
      const rect = gallery.getBoundingClientRect();
      if (rect.top >= HEADER_OFFSET && rect.top < window.innerHeight * 0.5) return;
      const y = rect.top + window.scrollY - HEADER_OFFSET;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }

    /* Valeurs actuellement sélectionnées, dans l'ordre des options */
    function getSelectedValues(picker) {
      return [...picker.querySelectorAll('.variant-picker__option')].map((opt) => {
        const select = opt.querySelector('select');
        if (select) return select.value;
        const checked = opt.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    /* true si la variante sélectionnée a sa propre image */
    function selectedVariantHasImage(picker) {
      const dataEl = picker.parentElement && picker.parentElement.querySelector('script[data-variant-media]');
      if (!dataEl) return false;
      let variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return false; }
      const selected = getSelectedValues(picker);
      const match = variants.find((v) =>
        v.options.every((val, i) => val === selected[i])
      );
      return Boolean(match && match.img);
    }

    document.addEventListener('change', (event) => {
      const input = event.target;
      const isSelect = input instanceof HTMLSelectElement;
      const isRadio = input instanceof HTMLInputElement && input.type === 'radio';
      if (!isSelect && !isRadio) return;

      const picker = input.closest('variant-picker');
      if (!picker) return;

      const option = input.closest('.variant-picker__option');
      const label = option && option.querySelector('.variant-picker__selected-value');
      const value = isSelect ? input.value : input.checked ? input.value : null;
      if (label && value) label.textContent = value;

      /* On vérifie tout de suite, avant que le thème ne recharge le bloc */
      const hasImage = selectedVariantHasImage(picker);
      if (hasImage) setTimeout(() => scrollToGallery(picker), 150);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
